import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Group } from '../../../dtos/group';

@Component({
  selector: 'app-group-invite-modal',
  standalone: false,
  templateUrl: './group-invite-modal.component.html',
  styleUrls: ['./group-invite-modal.component.scss'],
})
export class GroupInviteModalComponent implements OnChanges {
  @Input() open = false;
  @Input() inviteToken: string | null = null;
  @Input() group: Group | null = null;

  @Output() openChange = new EventEmitter<boolean>();
  @Output() requestJoin1 = new EventEmitter<string>();

  // parent can control these to show progress/errors
  @Input() requesting = false;
  @Input() errorMessage = '';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inviteToken']) {
      this.errorMessage = '';
      this.requesting = false;
    }
  }

  close(): void {
    this.open = false;
    this.openChange.emit(false);
  }

  requestJoin(): void {
    if (!this.inviteToken || this.requesting) {
      return;
    }

    this.requestJoin1.emit(this.inviteToken);
  }
}
